import './Header.scss';
class Header {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;

        // -- open nav -- //
            let hamburger = document.getElementById('hamburger');
            let nav = t.node.querySelector('.Header__nav');
            hamburger.addEventListener('click', () => {
                if( hamburger.classList.contains('active') ) {
                    nav.classList.add('active');
                    t.node.setAttribute('data-color', 'white' );
                } else {
                    nav.classList.remove('active');
                    t.node.setAttribute('data-color', t.node.getAttribute('data-color-def') );
                }
            });
            
            document.addEventListener('click', ( event ) => {
                if( !event.target.closest('.nav__wrapper') && !event.target.classList.contains('Hamburger') && nav.classList.contains('active') ) {
                    nav.classList.remove('active');
                    if( window.innerWidth > 960 ) {
                        t.node.setAttribute('data-color', t.node.getAttribute('data-color-def') );
                        hamburger.classList.remove('active');
                    }
                }
            });
            document.addEventListener('keydown', ( event ) => {

                if( event.code && event.code.toLowerCase() == 'escape' && hamburger.classList.contains('active') ) {
                    nav.classList.remove('active');
                    if( window.innerWidth > 960 ) {
                        t.node.setAttribute('data-color', t.node.getAttribute('data-color-def') );
                        hamburger.classList.remove('active');
                    }
                }
            });
        // -- END -- //
        
        // -- mobile info -- //
            let infoButton = t.node.querySelector('.Header__content .content__button');
            let infoBox = t.node.querySelector('.Header__info');
            infoButton.addEventListener('click', () => {
                if( infoButton.classList.contains('active') ) {
                    infoButton.classList.remove('active');
                    infoBox.classList.remove('active');
                } else {
                    infoButton.classList.add('active');
                    infoBox.classList.add('active');
                }
            });
            infoBox.querySelector('.info__button').addEventListener( 'click', () => {
                infoButton.classList.remove('active');
                infoBox.classList.remove('active');
            });
            document.addEventListener('click', ( event ) => {
                if( !event.target.classList.contains('content__button') && !event.target.closest('.Header__info') ) {
                    infoButton.classList.remove('active');
                    infoBox.classList.remove('active');
                }
            });
        // -- END -- //


        // -- header state -- //

            // -- color -- //
                if( document.body.classList.contains('Homepage') ) {
                    document.querySelector('header').insertAdjacentHTML('beforebegin','<div class="Header__line Header__line--before"></div>');
                    t.node.setAttribute('data-color-def', 'white');
                    let observer = new IntersectionObserver(
                        ( entries , index ) => {
                            entries.forEach( ( entry, index ) => {
        
                                if( entry.isIntersecting )  {
                                    t.node.setAttribute('data-color-def', 'transparent');
                                    t.node.setAttribute('data-color','transparent');
                                } else {
                                    t.node.setAttribute('data-color-def', 'white');
                                    t.node.setAttribute('data-color','white');
                                }
        
                            });
                        },
                        {
                            threshold: 0
                        }
                    );
                    observer.observe( document.querySelector('.Header__line--before') );
                }
            // -- END -- //

            // -- state -- //
                t.node.insertAdjacentHTML('beforebegin','<div class="Header__line Header__line--after"></div>');
                let currentPosition = window.scrollY;
                let headerHeight = t.node.offsetHeight;
                window.addEventListener('resize', function() {
                    headerHeight = t.node.offsetHeight;
                });
                window.addEventListener('scroll', () => {
                    if( !nav.classList.contains('active') ) {
                        if( window.scrollY > headerHeight ) {
                            if( currentPosition < window.scrollY ) { // scroll down
                                t.node.setAttribute('data-state','hide');
                            } else { // scroll top
                                t.node.setAttribute('data-state','show');
                            }
                        } else {
                            t.node.setAttribute('data-state','show');
                        }
                    }
                    currentPosition = window.scrollY;
                });
            // -- END -- //
        
        // -- END -- //

        // -- update buttons date -- //
            let lang = 'pl-PL';
            if( document.querySelector('html').hasAttribute('lang') ) {
                lang = document.querySelector('html').getAttribute('lang');
            }
            let dates = [];

            // -- current date -- //
                let date = new Date();
                let year = new Intl.DateTimeFormat( lang , { year: 'numeric' }).format(date);
                let month = new Intl.DateTimeFormat( lang , { month: 'short' }).format(date);
                let day = new Intl.DateTimeFormat( lang , { day: 'numeric' }).format(date);
                dates.push( day + ' ' + month + ' ' + year );
            // -- END -- //

            // -- current date + 3 days -- //
                let date3 = new Date(date.setDate(date.getDate() + 3 ));
                let day3 = new Intl.DateTimeFormat( lang , { day: 'numeric' }).format(date3);
                dates.push( day3 + ' ' + month + ' ' + year );
            // -- END -- //
            
            t.node.querySelectorAll('.content__calendar .calendar__row .row__button .button__date').forEach( ( span, index ) => {
                span.textContent = dates[index];
                span.closest('button').removeAttribute('disabled');
            });

        // -- END -- //

    }
}
JSModules['Header'] = Header;
export default Header;